import { Component, OnInit, ChangeDetectionStrategy, input } from '@angular/core';
import { Blog } from '../../models';
import { RouterLink } from '@angular/router';
import { CardComponent } from '../../../core/components/card/card.component';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { StripHtmlPipe, TruncatePipe } from '@teamfoster/sdk/text-utility';

@Component({
  selector: 'app-blog-block',
  templateUrl: './blog-block.component.html',
  styleUrls: ['./blog-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, CardComponent, FromDictionaryPipe, StripHtmlPipe, TruncatePipe],
})
export class BlogBlockComponent implements OnInit {
  readonly blogs = input<Blog[]>([]);

  constructor() {}

  ngOnInit(): void {}
}
